import { Action, Module, VuexModule } from "vuex-module-decorators";
import { WorkSchedule } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class WorkScheduleModule extends VuexModule {
    @Action
    [WorkSchedule.getWorkScheduleList]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/work-schedule/list`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [WorkSchedule.findPageWorkSchedule](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/work-schedule/show`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [WorkSchedule.saveWorkSchedule](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/work-schedule/save`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [WorkSchedule.deleteWorkSchedule](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/work-schedule/delete`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

}